// FINANCIALS widget - maps to data-provider/source/instructions/FINANCIALS
import type { RangeOption } from '../../../blocks/chart-widget';

export type FinancialsChartRange = '3Y' | '5Y' | '10Y' | 'ALL';

// Annual cadence: ranges slice by trailing fiscal-year count. Pills deeper
// than the fetched history are disabled (redundantRangeValues), never shown lying.
export const FINANCIALS_RANGE_OPTIONS: Array<RangeOption & { value: FinancialsChartRange }> = [
  { value: '3Y', label: '3Y', rows: 3 },
  { value: '5Y', label: '5Y', rows: 5 },
  { value: '10Y', label: '10Y', rows: 10 },
  { value: 'ALL', label: 'All' },
];

export interface FinancialsWidgetConfig {
  /** Initially selected chart range (user can change it on the widget). */
  defaultRange?: FinancialsChartRange;
}

export interface FinancialsWidgetInstanceConfig extends FinancialsWidgetConfig {
  dataKey?: string;
}

export interface FinancialsRow {
  fiscal_year: number | null;
  revenue: number | null;
  gross_profit: number | null;
  operating_income: number | null;
  net_income: number | null;
  net_margin: number | null;
}

export interface FinancialsData {
  ticker: string;
  last_fiscal_year: number | null;
  last_revenue: number | null;
  last_net_income: number | null;
  last_net_margin: number | null;
  financials_history: FinancialsRow[] | null;
}
